export const environment = {
  production: false,
  baseUrl: 'https://main.dev.tapgo.ch/app/v1', // For Local Database
  S3_URL: 'https://sos-ch-dk-2.exo.io/demo-tap-go/',
  END_POINTS: 'https://sos-ch-dk-2.exo.io',
  SPACE_NAME: 'demo-tap-go',
  simulated: 0,
  STRIPE_PUBLIC_KEY:
    'pk_live_51RQS8JB6uaQXxX8B9m7gDyadvT29TZbzsdyrMsXN1VggeJuBKrht4zvq9E8WfPlgG4UhLhD6ZUons0OyaLufAgRe00jfQQ4e1h',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
